import type { FC } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useFeatureSwitch } from '@xing-com/hub';

import { LoggedInLandingPage } from '../logged-in-landing-page/logged-in-landing-page';
import { LoggedOutLandingPage } from '../logged-out-landing-page/logged-out-landing-page';
import { RecommendedCompanies } from '../recommended-companies/recommended-companies';

export const Landing: FC = () => {
  const { isLoggedIn } = useLoginState();
  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  if (!isLoggedIn) {
    return <LoggedOutLandingPage />;
  }

  return showNewLoggedInOverview ? (
    <LoggedInLandingPage />
  ) : (
    <RecommendedCompanies />
  );
};
